// extracted by mini-css-extract-plugin
module.exports = {"tooltipWrapper":"_bde4009","genderMargin":"_100f3af","infoText":"_41f41ca","errorMessage":"_ce5ed4c"};